<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.affiliate_list") }}
  .section-body
    .row
      .col-12
        template(v-if="isOperator")
          affiliateListOperator
        template(v-else)
          affiliateListAdmin
</template>

<script>
import affiliateListAdmin from "@/components/affiliate/affiliateListAdmin.vue";
import affiliateListOperator from "@/components/affiliate/affiliateListOperator.vue";

export default {
  components: {
    affiliateListAdmin,
    affiliateListOperator
  },
  data: () => ({  }),
  computed: {
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_affiliatelist");
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {  },
  methods: {  }
};
</script>